import React, { ReactNode } from 'react';
type ArticleShellProps = {
  eyebrow: string;
  title: string;
  dek: string;
  meta?: string;
  children: ReactNode;
};
export function ArticleShell({
  eyebrow,
  title,
  dek,
  meta,
  children
}: ArticleShellProps) {
  return <main className="min-h-screen bg-[#FAF8F4] text-[#2B211A] pt-28 md:pt-36 pb-24" data-id="element-702" data-mp="y1m3lv3b2dgo">
    <article data-id="element-703" data-mp="12uf6edf7rbq4">
      <header className="max-w-[820px] mx-auto px-6 md:px-10 pb-10 md:pb-12" data-id="element-704" data-mp="12ux3tddm3vzm">
        <p className="text-xs font-bold tracking-[0.18em] uppercase text-[#EA580C] mb-5" data-id="element-705" data-mp="17rxa9pedj0r9">{eyebrow}</p>
        <h1 className="font-title text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-[-0.04em]" data-id="element-706" data-mp="1cqi85i65l8cj">
          {title}
        </h1>
        <p className="mt-7 text-lg md:text-xl leading-8 text-[#6B5D52]" data-id="element-707" data-mp="1hp1ydurs56ap">{dek}</p>
        {meta && <div className="mt-8 flex items-center gap-4" data-id="element-708" data-mp="1lqdpk4qaxzl0">
          <div className="w-12 h-12 rounded-full bg-white border border-[#DED6CC] shadow-sm flex items-center justify-center shrink-0" data-id="element-709" data-mp="3jjaza2m1bssk">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/c9cswf4udjck7zyoebqqwd/63a18a4c-5d20-4ad2-ba5f-9334c775fe47/Vector.png" alt="Giga" className="w-7 h-7 object-contain" data-id="element-710" data-mp="3nk4k2n46krh8" />
          </div>
          <div data-id="element-711" data-mp="dsluhgusmpm3">
            <p className="text-sm font-bold text-[#2B211A]" data-id="element-712" data-mp="ds2lipn4fbk7">Giga Editorial</p>
            <p className="mt-0.5 text-xs md:text-sm text-[#817469]" data-id="element-713" data-mp="8tiz6o4m7xrb">{meta}</p>
          </div>
        </div>}
      </header>
      <div className="max-w-[760px] mx-auto px-6 md:px-10" data-id="element-714" data-mp="16ht00zso0fgu">{children}</div>
    </article>
  </main>;
}
export function ArticleSection({
  id,
  title,
  intro,
  children
}: {
  id?: string;
  title: string;
  intro?: string;
  children: ReactNode;
}) {
  return <section id={id} className="scroll-mt-28 py-10 md:py-14" data-id="element-715" data-mp="wl6fkc493qfc">
    <h2 className="font-title text-3xl md:text-4xl tracking-[-0.03em] leading-[1.12]" data-id="element-716" data-mp="riz1ngzv20ad">{title}</h2>
    {intro && <p className="mt-5 text-lg leading-8 text-[#6B5D52] max-w-[760px]" data-id="element-717" data-mp="3ha3xnazmf8g6">{intro}</p>}
    <div className="mt-8" data-id="element-718" data-mp="3c96ht5232qhu">{children}</div>
  </section>;
}
export function ArticleCallout({
  label,
  children,
  action
}: {
  label?: string;
  children: ReactNode;
  action?: ReactNode;
}) {
  return <aside className="border-l-4 border-[#EA580C] bg-white p-6 md:p-8" data-id="element-719" data-mp="28bckja1y18xt">
    {label && <p className="text-xs font-bold tracking-[0.16em] uppercase text-[#C2410C] mb-4" data-id="element-720" data-mp="1ud4feeur71bk">{label}</p>}
    <div className="text-xl md:text-2xl font-title leading-snug text-[#2B211A]" data-id="element-721" data-mp="1zb6axz9d8t3x">{children}</div>
    {action && <div className="mt-7" data-id="element-722" data-mp="1km9w9jct0huc">{action}</div>}
  </aside>;
}
export function ArticleTable({
  headers,
  rows
}: {
  headers: string[];
  rows: ReactNode[][];
}) {
  return <div className="overflow-x-auto border-y border-[#CFC5BA] bg-white md:w-[calc(100%+160px)] md:-ml-20" data-id="element-723" data-mp="1pfcq7slhttb2">
    <table className="w-full min-w-[760px] border-collapse text-left" data-id="element-724" data-mp="1bkadomm555pa">
      <thead data-id="element-725" data-mp="1glg60jbw2qya">
        <tr className="bg-[#F1ECE5]" data-id="element-726" data-mp="1gj3mw2ueaajn">
          {headers.map(header => <th key={header} className="px-5 py-4 text-xs font-bold uppercase tracking-wider text-[#6B5D52]" data-id="element-727" data-mp="11p8ltj0hdpj0">{header}</th>)}
        </tr>
      </thead>
      <tbody data-id="element-728" data-mp="16ov2y3jfjpx3">
        {rows.map((row, rowIndex) => <tr key={rowIndex} className="border-t border-[#E7E0D7] align-top" data-id="element-729" data-mp="n29vjrdd115v" data-mpi={rowIndex}>
          {row.map((cell, cellIndex) => <td key={cellIndex} className="px-5 py-5 text-sm leading-6 text-[#51453C] first:font-bold first:text-[#2B211A]" data-id="element-730" data-mp="j0yfodkafuav" data-mpi={cellIndex}>{cell}</td>)}
        </tr>)}
      </tbody>
    </table>
  </div>;
}